import { Dimensions, StyleSheet, } from 'react-native';
const isNotUndefind = (val) => typeof val !== 'undefined';
export function styles(styleRules) {
    const st = StyleSheet.create({
        default: styleRules,
    });
    return st.default;
}
export function borderRadius(top, right, bottom, left) {
    return {
        borderTopLeftRadius: top,
        borderTopRightRadius: isNotUndefind(right) ? right : top,
        borderBottomRightRadius: isNotUndefind(bottom) ? bottom : top,
        borderBottomLeftRadius: isNotUndefind(left)
            ? left
            : isNotUndefind(right)
                ? right
                : top,
    };
}
export function vh(percentage) {
    const viewportHeight = Dimensions.get('window').height;
    const decimal = percentage * 0.01;
    percentage = parseInt(percentage, 10);
    // Hard limits
    if (percentage < 0) {
        percentage = 100;
    }
    if (percentage > 1000) {
        percentage = 1000;
    }
    return Math.round(viewportHeight * decimal);
}
export function vw(percentage) {
    const viewportWidth = Dimensions.get('window').width;
    const decimal = percentage * 0.01;
    percentage = parseInt(percentage, 10);
    // Hard limits
    if (percentage < 0) {
        percentage = 100;
    }
    if (percentage > 1000) {
        percentage = 1000;
    }
    return Math.round(viewportWidth * decimal);
}
